import { apiGet, apiPost } from '@/core/api';
import { engagementId, sessionState } from '@/core/session';
import { HomePageOffers, PartnerOffer } from '@/features/partnerOffers/model';
import { InteractionType } from '@/features/analytics/api';

export const getHomePageOffers = async () => apiGet<HomePageOffers>('/portal/citizen/homePageOffers');

export const getOffers = async () => apiGet<PartnerOffer[]>('/portal/citizen/offers');

export const getOffer = async (id: string) => apiGet<PartnerOffer>(`/portal/citizen/offers/${id}`);

export const logImpressions = async (context: string, offers: PartnerOffer[]) => {
    const events = [];
    for (const offer of offers) {
        events.push({
            offerId: offer.id,
            sessionId: sessionState.session?.id,
            engagementId: engagementId.value,
            type: InteractionType.IMPRESSION,
            context: "citizenPortal/" + context,
            data: null
        });
    }

    apiPost(
        'analytics/citizens/partnerOffers',
        {events: events}
    );
};

export const logInteraction = async (context: string, offer: PartnerOffer, type: InteractionType, data?: string) => {
    const events = [{
        offerId: offer.id,
        sessionId: sessionState.session?.id,
        engagementId: engagementId.value,
        type: type,
        context: "citizenPortal/" + context,
        data: data
    }];

    apiPost(
        'analytics/citizens/partnerOffers',
        {events: events}
    );
};